import { FC, ReactNode } from 'react';
import { ControllerFieldState } from 'react-hook-form/dist/types/controller';

interface IProps {
  children: ReactNode;
  state: ControllerFieldState;
}

const FormFieldWrapper: FC<IProps> = ({ children, state }) => {
  return (
    <div className={`${state.invalid ? 'border border-solid border-[#FF173A] rounded-[5px]' : ''}`}>
      {children}
    </div>
  );
};

export default FormFieldWrapper;
